import { IParameter } from "../types";
import { buildFetch, buildRequestBody } from "../utils";
import { getParamsGET_ALL_VEHICLES, getParamsGET_VEH_COORDS } from "./params";
import { IGetParamsGET_ALL_VEHICLES, IGetParamsGET_VEH_COORDS, IResponseGET_ALL_VEHICLES, IResponseGET_VEH_COORDS } from "./types";


const apiTransport = {
    async getLocationTransport(params: IGetParamsGET_VEH_COORDS): Promise<IResponseGET_VEH_COORDS> {
        try {
            const parameters: IParameter[] = getParamsGET_VEH_COORDS(params);
            const body = buildRequestBody({ parameters, city_id: params.NCITY_ID?.toString() ?? '', object_name: "GET_VEH_COORDS" });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching bus stations:', error);
            throw new Error('Failed to fetch bus stations. Please try again later.');
        }
    },

    async getAllTransportOnCity(params: IGetParamsGET_ALL_VEHICLES): Promise<IResponseGET_ALL_VEHICLES> {
        try {
            const parameters: IParameter[] = getParamsGET_ALL_VEHICLES(params);
            const body = buildRequestBody({
                parameters,
                city_id: params.city_id?.toString() ?? '',
                object_name: "GET_ALL_VEHICLES"
            });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching bus stations:', error);
            throw new Error('Failed to fetch bus stations. Please try again later.');
        }
    },
};

export default apiTransport;